import React from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import { useLocation } from 'react-router-dom';
import { consentPluginConfig } from './consentConfig';
import { initMatamo } from '../../containers/App/matomo';
import '../../styles/cookieconsent-style-overrides.css';
import EGASS from '../../containers/EGASS';

const CookieConsentComponent = () => {
  const location = useLocation();
  const locale = location?.pathname?.split('/')?.[1] || 'en';

  React.useEffect(() => {
    CookieConsent.run({
      ...consentPluginConfig,
      onConsent: () => {
        CookieConsent.acceptedCategory('analytics');
        CookieConsent.acceptedCategory('marketing');
        if (CookieConsent.acceptedCategory('analytics')) {
          initMatamo();
        }
        if (CookieConsent.acceptedCategory('marketing')) {
          new EGASS().call(window.location);
        }
      },
      onChange: () => {
        CookieConsent.acceptedCategory('analytics');
        CookieConsent.acceptedCategory('marketing');
        if (CookieConsent.acceptedCategory('analytics')) {
          initMatamo();
        }
        if (CookieConsent.acceptedCategory('marketing')) {
          new EGASS().call(window.location);
        }
      },
    });
  }, []);

  React.useEffect(() => {
    CookieConsent.setLanguage(locale);
  }, [locale]);

  return null;
};

export default CookieConsentComponent;
